module.exports = __webpack_public_path__ + "media/images/social-share-button/whatsapp-8f3586f10ca30504aed4ff5ae38a965b.svg";